import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-civic-service-info',
  templateUrl: './civic-service-info.component.html',
  styleUrls: ['./civic-service-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CivicServiceInfoComponent {
  @Output() eventTracker = new EventEmitter<void>();

  FeaturesRoutingEnum = FeaturesRoutingEnum;

  get isMobile$(): Observable<boolean> {
    return this.breakpointsService.isMobile$;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}
}

@NgModule({
  imports: [CommonModule, MatIconModule, RouterModule],
  declarations: [CivicServiceInfoComponent],
  exports: [CivicServiceInfoComponent],
})
export class CivicServiceInfoModule {}
